module.exports = __webpack_public_path__ + "img/progress_025.167d4ed5.png";